import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../Redux/Store/Store';
import { setClient } from '../Redux/Store/Slices/client';
import { clientService } from '../services/clientService';

export const useAutoSwitchClient = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { clientOptions, activeClient } = useSelector((state: RootState) => state.client);

  useEffect(() => {
    if (clientOptions.length > 0 && !activeClient) {
      const switchToLastActiveClient = async () => {
        try {
          const lastActiveClient = await clientService.getCurrentUserActiveClient();
          if (lastActiveClient) {
            const clientOption = clientOptions.find(client => client.id === lastActiveClient.clientId);
            if (clientOption) {
              dispatch(setClient({ 
                userSub: '',
                clientId: lastActiveClient.clientId 
              }));
              return;
            }
          }
          dispatch(setClient({ 
            userSub: '', 
            clientId: clientOptions[0].id 
          }));
        } catch (error) {
          dispatch(setClient({ 
            userSub: '', 
            clientId: clientOptions[0].id 
          }));
        }
      };
      
      switchToLastActiveClient();
    }
  }, [dispatch, clientOptions, activeClient]);
};
